import { createRoute } from '@tanstack/react-router';
import { TarifForm } from '@/modules/pujcovna/TarifForm';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/sprava/tarify/novy',
  component: TarifForm,
});
